import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { CalendarService } from '@app/modules/microsoft-graph/services/graph-calendar.service';
import { CustactGet, CustactService } from '@app/services/custact.service';

@Component({
    selector: 'tt-work-details-register-functions',
    templateUrl: './work-details-register-functions.component.html',
    styleUrls: ['./work-details-register-functions.component.css'],
})
export class WorkDetailsRegisterFunctionsComponent {
    @Input()
    public params?: CustactGet;

    @Output()
    public deleted = new EventEmitter();

    public deleting = false;

    constructor(
        private custact: CustactService,
        private calendar: CalendarService,
        private cdr: ChangeDetectorRef,
    ) {}

    public async deleteCustact() {
        if (!this.params) return;

        try {
            this.deleting = true;

            const response = await this.custact.deleteCustact(this.params);

            if (!!response && typeof response === 'object' && 'ok' in response && (response.ok === '1' || response.ok === 1)) {
                if (this.params.microsoft_graph_event_id.length > 0) {
                    await this.calendar.deleteEvent(this.params.microsoft_graph_event_id);
                }

                this.deleted.emit();
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.deleting = false;
            this.cdr.markForCheck();
        }
    }
}
